import React from "react";
import "./certificatecard.css";

function CertificateCard({ imgSrc, imgAltMessage, beforeBreak, afterBreak }) {
  return (
    <div className="certificatecards-container">
      <img src={imgSrc} alt={imgAltMessage} loading="lazy" decoding="async" />
      <p>
        {beforeBreak}
        <br />
        {afterBreak}
      </p>
    </div>
  );
}

export default React.memo(CertificateCard);
